<template>
  <div
    class="layer-overlay"
    :class="[environmentClass, environmentClass === 'stage' ? 'btn-primary' : 'btn-danger']"
  >
    <strong>{{ environmentText }}</strong>
  </div>
</template>

<script>
export default {
  name: 'EnvironmentIndicator',
  data() {
    return {
      applicationIdentifier: brain.company.json.id,
    };
  },
  computed: {
    environmentText() {
      if (this.applicationIdentifier.includes('stage-')) return 'HOMOLOGAÇÃO';
      return 'DESENVOLVIMENTO';
    },
    environmentClass() {
      if (this.applicationIdentifier.includes('stage-')) return 'stage';
      return 'development';
    },
  },
};
</script>

<style lang="scss">
.development {
  background: #cc3a3a !important;
  bottom: 0;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  margin-left: 1vh;
  opacity: 0.9;
  &:hover {
    opacity: 1;
  }
  padding: 10px;
  position: fixed;
}

.stage {
  bottom: 0;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  margin-left: 1vh;
  padding: 10px;
  position: fixed;
}
</style>
